import { NotificationActionRequest } from '@smatchy/notification';

export type NotificationFilterId = 'all' | 'unread' | 'events' | 'finance' | 'groups' | 'accounts';

export type NotificationInboxCategory = 'events' | 'finance' | 'groups' | 'accounts';

export interface NotificationInboxItemDto {
  id: string;
  avatarUrl: string;
  title?: string;
  statusType:
    | 'warning'
    | 'error'
    | 'success'
    | 'message'
    | 'approval'
    | 'revoke'
    | 'incoming_payment'
    | 'outgoing_payment'
    | 'remind'
    | 'new'
    | 'no_refund'
    | 'delete';
  message: string;
  timestamp: string;
  isUnread: boolean;
  senderName?: string;
  category: NotificationInboxCategory;
  action: NotificationActionRequest;
  /**
   * Since 20 October 2026, who the entry is from and their line. Absent from
   * an older API, on an entry from nobody, and on one from somebody a block
   * separates from me: the entry is then drawn as before.
   */
  senderUserId?: string;
  senderLine?: Record<string, unknown>;
}

export interface GetMyNotificationsResponseDto {
  notifications: NotificationInboxItemDto[];
  haveNext: boolean;
  nextCursor?: string;
}

export interface GetUnreadNotificationCountResponseDto {
  count: number;
}

export interface NotificationInboxCountsDto {
  all: number;
  unread: number;
  byCategory: Record<NotificationInboxCategory, number>;
  unreadByCategory: Record<NotificationInboxCategory, number>;
}

export interface GetNotificationCountsResponseDto {
  counts: NotificationInboxCountsDto;
}

export function toApiFilter(filter: NotificationFilterId): string {
  return filter;
}
